module.exports = __webpack_public_path__ + "static/media/guiaVer.de5b8148.png";